import React, { useEffect, useState } from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { Controller, useForm } from "react-hook-form";
import {
  asyncPostData,
  asyncPutData,
  uploadFile,
} from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import {
  Avatar,
  Box,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import TextInput from "../../input/TextInput";
import SelectApiInput from "../../input/SelectApiInput";
import { cloneDeep, isArray } from "lodash";
import { generateLinkImage } from "../../../../utils/helpers";
import { v4 } from "uuid";
import { LuXCircle } from "react-icons/lu";

const schema = yup.object({
  group: yup
    .object()
    .typeError("Vui lòng chọn loại liên hệ")
    .required("Vui lòng chọn loại liên hệ"),
  content: yup.string().required("Vui lòng nhập nội dung liên hệ"),
  trang_thai: yup
    .object()
    .typeError("Vui lòng chọn trạng thái")
    .required("Vui lòng chọn trạng thái"),
});

function FormComplaint({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const [images, setImages] = useState<File[]>([]);
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [defaulImages, setDefaultImages] = useState<any[]>(
    defaultValues?.attends || []
  );
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    content: "",
    group: null,
    parentId: "",
    trang_thai: null,
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        group: defaultValues?.of_id
          ? {
              _id: defaultValues?.of_id || "",
              group_name: defaultValues?.of_name || "",
            }
          : null,
        trang_thai: defaultValues?.trang_thai
          ? {
              ma_trang_thai: defaultValues?.trang_thai,
              ten_trang_thai: defaultValues?.ten_trang_thai,
            }
          : null,
      }
    : null;

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const deleteDefaultImage = (index: number) => {
    if (!defaulImages) return;
    const imagesClone = cloneDeep(defaulImages);
    const newImages: any[] = [];
    for (let i = 0; i < imagesClone.length; i++) {
      if (index !== i) {
        newImages.push(imagesClone[i]);
      }
    }
    setDefaultImages(newImages);
  };

  const deleteImage = (index: number) => {
    if (!images) return;
    const imagesClone = cloneDeep(images);
    const newImages: File[] = [];
    for (let i = 0; i < imagesClone.length; i++) {
      if (index !== i) {
        newImages.push(imagesClone[i]);
      }
    }
    setImages(newImages);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const { group, trang_thai, ...fields } = values;
    const result = {
      ...fields,
      attends: [...(defaulImages || [])],
      of_id: group?._id || "",
      of_name: group?.group_name,
      trang_thai: trang_thai?.ma_trang_thai || "",
    };
    // save image
    if (isArray(images) && images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        const formData = new FormData();
        formData.append("file", images[i]);
        const resp = await uploadFile({
          formData,
          folder: "complaint",
          token,
        });
        result.attends.push({
          ...resp?.data,
          url: generateLinkImage(resp?.data?.fileUrl),
        });
      }
    }
    return result;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  useEffect(() => {
    if (!!images && images.length > 0) {
      let urls = [];
      for (let i = 0; i < images.length; i++) {
        urls.push(URL.createObjectURL(images[i]));
      }
      setImageUrls(urls);
    } else {
      setImageUrls([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);

  useEffect(() => {
    return () => {
      imageUrls.forEach((url) => {
        URL.revokeObjectURL(url);
      });
    };
  }, [imageUrls]);

  return (
    <ModalForm
      formWidth="500px"
      formTitle="liên hệ"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <Controller
          name="group"
          control={control}
          render={({ field: { value, onChange } }) => {
            return (
              <SelectApiInput
                required
                labelWidth="25%"
                label="Loại liên hệ"
                placeholder="Chọn loại liên hệ"
                apiCode="group"
                searchFields={["group_name"]}
                defaultCondition={{ group_type: "COMPLAINT" }}
                getOptionLabel={(option) => option.group_name}
                checkEqual={(value, option) => value?._id === option?._id}
                value={value}
                onChange={onChange}
                errorMessage={errors?.group?.message as string}
              />
            );
          }}
        />
        <TextInput
          required
          multiline
          label="Nội dung"
          labelWidth="25%"
          placeholder="Nhập nội dung"
          name="content"
          register={register}
          errorMessage={errors?.content?.message as string}
        />
        <Controller
          name="trang_thai"
          control={control}
          render={({ field: { value, onChange } }) => {
            return (
              <SelectApiInput
                required
                labelWidth="25%"
                label="Trạng thái"
                placeholder="Chọn trạng thái"
                apiCode="trangthai"
                withIdApp={false}
                defaultCondition={{ ma_ct: "comment2" }}
                searchFields={["ma_trang_thai", "ten_trang_thai"]}
                getOptionLabel={(option) => option?.ten_trang_thai}
                checkEqual={(value, option) =>
                  value?.ma_trang_thai === option?.ma_trang_thai
                }
                value={value}
                onChange={onChange}
                errorMessage={errors?.trang_thai?.message as string}
              />
            );
          }}
        />
        {/* Hinh anh */}
        <Box>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography>Hình ảnh</Typography>
            <Box
              key={v4()}
              component="input"
              type="file"
              multiple={true}
              accept="image/*"
              onChange={(e) => {
                const files = e.target.files;
                setImages([...(images || []), ...Array.from(files || [])]);
              }}
            ></Box>
          </Stack>
          <Box sx={{ pt: 1 }}>
            <Grid2 container spacing={1}>
              {isArray(defaulImages) &&
                defaulImages.map((img, index) => {
                  return (
                    <Grid2 key={v4()} size={{ xs: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <IconButton
                          onClick={() => deleteDefaultImage(index)}
                          sx={{
                            position: "absolute",
                            zIndex: 10,
                            top: "5px",
                            right: "5px",
                            backgroundColor: "background.paper",
                            color: "text.primary",
                            boxShadow: "0px 0px 5px 1px #00000055",
                            "&:hover": {
                              backgroundColor: "background.paper",
                            },
                          }}
                        >
                          <LuXCircle size={20} />
                        </IconButton>
                        <Avatar
                          src={
                            img?.fileUrl ? generateLinkImage(img.fileUrl) : ""
                          }
                          sx={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "2px solid",
                            borderColor: "divider",
                          }}
                        />
                      </Box>
                    </Grid2>
                  );
                })}
              {isArray(images) &&
                images.length > 0 &&
                images.map((media, index) => {
                  return (
                    <Grid2 key={v4()} size={{ xs: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <IconButton
                          onClick={() => deleteImage(index)}
                          sx={{
                            position: "absolute",
                            zIndex: 10,
                            top: "5px",
                            right: "5px",
                            backgroundColor: "background.paper",
                            color: "text.primary",
                            boxShadow: "0px 0px 5px 1px #00000055",
                            "&:hover": {
                              backgroundColor: "background.paper",
                            },
                          }}
                        >
                          <LuXCircle size={20} />
                        </IconButton>
                        <Avatar
                          src={imageUrls[index]}
                          sx={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "2px solid",
                            borderColor: "divider",
                          }}
                        />
                      </Box>
                    </Grid2>
                  );
                })}
            </Grid2>
          </Box>
        </Box>
      </Stack>
    </ModalForm>
  );
}

export default FormComplaint;
